import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(5.11vw, 73px) min(9.73vw, 139px);
  align-items: center;
  background-color: #ffffff;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  .blue-text {
    line-height: min(5.53vw, 79px);
    color: #095587;
    margin: 0;
  }
  h4 {
    font-size: min(4.2vw, 60px);
    line-height: min(4.2vw, 60px);

    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(1.26vw, 18px);
    text-align: center;
  }
  h5 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(3.5vw, 50px);
    color: #095587;
    text-align: center;
    max-width: min(1036px, 72vw);
  }
  button {
    width: min(11.13vw, 159px);
    height: min(2.73vw, 39px);
    font-size: min(1.19vw, 17px);
    border-radius: min(0.42vw, 6px);
    background-color: #095587;
    font-family: "robotoregular";
    color: #fff;
    margin: min(2.03vw, 29px) auto 0;
    border: none;
  }
  @media (max-width: 767px) {
    padding: min(5.11vw, 73px);

    h4 {
      /* font-size: 4.7vw;*/
      line-height: 4vw;
      margin-bottom: 2.42vw;
    }
    h5 {
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
      max-width: 100%;
    }
    button {
      width: 31.7vw;
      height: 7.74vw;
      font-size: 3.38vw;
      border-radius: 6px;
    }
  }
`;
const GroupSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: min(3.5vw, 50px) min(1.61vw, 23px);
  > div:last-child {
    h6 {
      max-width: min(10.5vw, 150px);
    }
  }
  @media (max-width: 767px) {
    display: flex;
    flex-wrap: wrap;
    gap: 4.84vw;
    justify-content: center;
    > div:last-child {
      h6 {
        max-width: 23.94vw;
      }
    }
  }
`;
const BoxSection = styled.div`
  text-align: center;
  display: grid;
  /* grid-template-rows: min(9.7vw, 153px) min(4.8vw 76px) auto; */
  grid-template-rows: auto;
  border: 2px solid;
  border-color: transparent;
  position: relative;
  :hover {
    border-color: #095587;
  }
  .youtube-icon {
    width: 10%;
    /* height: 100%; */
    aspect-ratio: auto 273.25/191.08;
    margin: 0 auto;
    position: absolute;
    right: 2%;
    bottom: 4%;
  }
  .banner-wrapper {
    position: relative;
    aspect-ratio: 16/9;
    height: min(10.4vw, 153px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: radial-gradient(
      57.58% 57.58% at 50% 50%,
      #0b5687 0%,
      #054f7a 42.19%,
      #003253 88.02%,
      #032b46 100%
    );
    .inner-text {
      color: #ffffffb8;
      padding: 0 10px;
    }
  }
  h6 {
    font-size: min(1.26vw, 18px);
    line-height: min(1.47vw, 21px);
    color: #095587;
    font-family: "robotobold";
    margin: min(1.05vw, 15px) auto min(1.19vw, 17px);
    height: min(3vw, 44px);
  }
  p {
    /* width: min(14.98vw, 214px); */
    /* height: min(9.66vw, 138px); */
    font-size: min(1.19vw, 17px);
    line-height: min(1.61vw, 23px);
    color: #095587;
    font-family: "robotoregular";
    margin: 0;
    /* margin-top: 15px; */
    margin-bottom: 10px;
    /* display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; */
  }
  a {
    font-size: min(1.19vw, 17px);
    line-height: min(1.61vw, 23px);
    color: #095587;
    font-family: "robotobold";
    margin: 0;

    /* font-size: min(1.19vw, 17px);
    line-height: min(1.61vw, 23px);
    color: #095587;
    font-family: "robotoregular";
    margin: 0;
    margin-top: 15px; */
  }
  a:hover {
    font-family: "robotobold";
    color: #70ac08;
    text-decoration: underline !important;
  }
  img {
    align-self: center;
    margin: 0 auto;
    /* width: min(8.96vw, 128px); */
    height: min(8.47vw, 121px);
    color: #005586;
    border: 2px solid transparent;
    :hover {
      border-color: blue;
      font-size: 14px;
    }
  }

  @media (max-width: 767px) {
    max-width: 32vw;
    grid-template-rows: 17.92vw 11.55vw auto;
    .banner-wrapper {
      height: min(17.92vw, 153px);
    }
    h6 {
      font-size: 2.94vw;
      line-height: 3.14vw;
      margin-bottom: 2.42vw;
      height: auto;
    }
    p {
      width: auto;
      height: auto;
      font-size: 2.66vw;
      line-height: 2.9vw;
      margin-bottom: 2.42vw;
    }
    a {
      font-size: min(2.19vw, 17px);
      line-height: min(2.61vw, 23px);
    }
  }
`;
export { Container, Wrapper, GroupSection, BoxSection };
